import { executeOnce } from '../../../utils'

import { Usecase } from '../Usecase'

export abstract class CommissioningFileUsecase extends Usecase {
    readonly getSupportedCommissioningFileTypes = executeOnce(() => this.configurationService.getSupportedServiceCommissioningFileTypes())
}
